export default __webpack_public_path__ + "static/medvision_light_logo-b10041decb57c2b9276c03547f83b6f3.svg";